import dayjs from 'utils/dayjsConfig';

function toPackWeekOption(key, date) {
    return {
        key,
        week: date.isoWeek(),
        year: date.isoWeekYear(),
    };
}

/**
 * Builds previous / current / next pack week options.
 * On Sunday (except ISO week 53), "current" is the upcoming week.
 *
 * @param {import('dayjs').Dayjs} [date]
 * @returns {Array<{ key: 'previous' | 'current' | 'next', week: number, year: number }>}
 */
function buildPackWeekOptions(date = dayjs()) {
    let current = dayjs(date);
    // Pack week treats Sunday as the upcoming week (matching getSundayAdjustedWeekNumber).
    if (current.day() === 0 && current.isoWeek() < 53) {
        current = current.add(1, 'week');
    }
    return [
        toPackWeekOption('previous', current.subtract(1, 'week')),
        toPackWeekOption('current', current),
        toPackWeekOption('next', current.add(1, 'week')),
    ];
}

export { buildPackWeekOptions };
